/**
 * Slugify utility functions for generating URL-friendly slugs
 */

/**
 * Convert text to URL-friendly slug
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (é -> e)
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with -
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing dashes
}

/**
 * Generate shop slug: province/city/shop-name
 * For kringloopwinkels or horeca
 */
export function generateShopSlug(province: string, city: string, name: string): string {
  return `${slugify(province)}/${slugify(city)}/${slugify(name)}`;
}

/**
 * Generate route slug: just route-name
 */
export function generateRouteSlug(name: string): string {
  return slugify(name);
}

/**
 * Parse shop slug back to parts
 */
export function parseShopSlug(slug: string): { province: string; city: string; name: string } | null {
  const parts = slug.split('/');
  if (parts.length !== 3) {
    return null;
  }
  return {
    province: parts[0],
    city: parts[1],
    name: parts[2],
  };
}

/**
 * Parse route slug (same as name for routes)
 */
export function parseRouteSlug(slug: string): string {
  return slug;
}
